export const toCompactDatePart = (value: string | null | undefined): string => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const dateMatch = raw.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) {
    return `${dateMatch[1]}${dateMatch[2]}${dateMatch[3]}`;
  }

  return raw.replace(/\D/g, '').slice(0, 8);
};

export const toCompactTimePart = (value: string | null | undefined): string => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const timeMatch = raw.match(/(\d{2}):(\d{2})/);
  if (timeMatch) {
    return `${timeMatch[1]}${timeMatch[2]}`;
  }

  return raw.replace(/\D/g, '').slice(0, 4);
};

export const toCompactDateTimeRangePart = (
  date: string | null | undefined,
  timeFrom: string | null | undefined,
  timeTo: string | null | undefined,
): string => {
  const compactDate = toCompactDatePart(date);
  const compactTimeFrom = toCompactTimePart(timeFrom);
  const compactTimeTo = toCompactTimePart(timeTo);
  if (!compactDate || !compactTimeFrom) return '';

  const compactDateTime = `${compactDate}T${compactTimeFrom}`;
  if (!compactDateTime || !compactTimeTo) return compactDateTime;
  return `${compactDateTime}-${compactTimeTo}`;
};
